
export enum UserType {
  Mobile = 0,
  Web = 1,
}

export class UserManagementData {
  data: any;
  type: UserType | null = null;
}
